import Axios from 'axios';
import { configure } from 'axios-hooks';
import React, { ReactNode } from 'react';
import { BASE_API_URL, FIREBASE_PROJECTID } from '../../lib/Constants';

export const axios = Axios.create({ baseURL: BASE_API_URL });

// eslint-disable-next-line no-underscore-dangle
if (window.__attnAxiosInterceptor) {
  // eslint-disable-next-line no-underscore-dangle
  axios.interceptors.request.use(window.__attnAxiosInterceptor);
}

// Sets the default headers on all request types
axios.defaults.headers.common.FirebaseProject = FIREBASE_PROJECTID as string;

configure({ axios });

type TAxiosProvider = {
  children: ReactNode;
};

export default function AxiosProvider({ children }: TAxiosProvider) {
  return <>{children}</>;
}
